import { useMemo, useState } from "react";

export default function useTermsOfServiceModal() {
  const [show, setShow] = useState(false);

  return useMemo(() => ({ show, setShow }), [show, setShow]);
}
